<template>
  <div style="min-height: 92vh">
    <div v-show="!showCreator">
      <ModuleHeader
        >Documentos de producción de insumos elaborados</ModuleHeader
      >
      <v-card class="mb-5" flat>
        <v-card-text class="ma-1">
          <v-row>
            <v-col md="5" cols="12">
              <label>Fecha inicial</label>
              <Datepicker
                :input-class="'v-input__control theme--light v-text-field dateinputClass pa-1'"
                @selected="(date) => selectDate(date, 1)"
                :value="input_date.format('YYYY/MM/DD')"
              ></Datepicker>
            </v-col>
            <v-col md="5" cols="12">
              <label>Fecha final</label>
              <Datepicker
                :input-class="'v-input__control theme--light v-text-field dateinputClass pa-1'"
                @selected="(date) => selectDateFinal(date, 1)"
                :disabled-dates="disableDates"
                :value="input_date_final.format('YYYY/MM/DD')"
              ></Datepicker>
            </v-col>
            <v-col md="2" cols="12" class="text-center align-content-center">
              <v-btn color="success" @click="getDocuments()"> Buscar </v-btn>
            </v-col>
          </v-row>
        </v-card-text>
      </v-card>
      <uv-data-table
        :config="config"
        :data="Documentos"
        :pageRows="15"
        @buttonClick="dtButtonClick"
        @buttonOptClick="optButtonClick"
      ></uv-data-table>
    </div>

    <modal
      v-model="showModal"
      :showFooter="false"
      :fullscreen="true"
      title="Produccion de insumos elaborados"
    >
      <ProduccionAYBForm
        :edit="editMode"
        @toggle="toggleModal"
        @successData="successData"
        :key="formIndex"
        :dataEdit="editData"
      />
    </modal>
  </div>
</template>

<style></style>

<script>
import moment from "moment";
import modal from "../../MainComponents/modal.vue";
import uvDataTable from "../../MainComponents/DataTable.vue";
import ProduccionAYBForm from "./ProduccionAYBForm.vue";
import Datepicker from "vuejs-datepicker";

export default {
  name: "ProduccionAYB",
  components: {
    modal,
    uvDataTable,
    ProduccionAYBForm,
    Datepicker,
  },
  props: [],
  data() {
    return {
      origenes: [],
      self: this,
      showModal: false,
      formKey: 0,
      Documentos: [],
      formIndex: 0,
      editMode: false,
      showCreator: false,
      creatorIndex: 0,
      editData: [],
      hoteles: [],
      usuarios: [],
      editedHotel: {},
      config: {
        selectableRow: true,
        orderByCol: { Field: "", Type: "Asc" },
        selectConfig: {
          idRowData: "id", // id necesario para indicar id unico del row que esta seleccionado y retornarlo en los eventos requeridos
        },
        buttons: [
          {
            text: "Nueva produccion de insumos",
            icon: "lni lni-clipboard",
            buttonId: "addProduccion",
          },
          {
            text: "Editar",
            icon: "lni lni-pencil-alt",
            buttonId: "editProduccion",
            require: true,
          },
          {
            text: "Cancelar producción",
            icon: "lni lni-trash",
            buttonId: "deleteProduccion",
            require: true,
          },
          {
            text: "Replicar producción",
            icon: "lni lni-reload",
            buttonId: "replyProduccion",
            require: true,
          },
        ],
        fields: [
          {
            text: "Documento de produccion",
            value: "Nombre",
          },
          {
            text: "Fecha Creación",
            value: "Fecha",
          },
          {
            text: "Departamento",
            value: "Departamento",
          },
          {
            text: "Estatus",
            value: "Status",
            format: (row) => {
              if (row["Status"] == "A") {
                return '<b style="color:green;">Aplicado</b>';
              } else if(row["Status"] == "P") {
                return '<b style="color:orange;">Pendiente</b>';
              } else {
                return '<b style="color:red;">Cancelado</b>';
              } 
            },
          },
          {
            text: "Opciones",
            value: "id",
            buttons: [
              {
                color: "green",
                text: "Aplicar",
                buttonId: "aplicarProd",
                value: "id",
                showBy: "Showby"
              },
            ],
          },
        ],
      },

      input_date: new moment(),
      input_date_final: new moment(),
    };
  },
  methods: {
    selectDate(arg) {
      this.input_date = moment(arg);
      this.input_date_final = moment(arg);
    },
    selectDateFinal(arg) {
      this.input_date_final = moment(arg);
    },
    dtButtonClick(buttonId, idSelected) {
      if (buttonId == "addProduccion") {
        this.formIndex++;
        this.editMode = false;
        this.editData = null;
        this.showModal = true;
      }
      if (buttonId == "editProduccion") {
        this.formIndex++;
        this.editMode = true;
        this.editData = this.$pgsHelper.getById(
          this.Documentos,
          "id",
          idSelected[0]
        );

        this.showModal = true;
      }

      if (buttonId == "deleteProduccion") {
        this.deleteDoc(idSelected[0]);
      }
      if (buttonId == "replyProduccion") {
        this.replyProduccion(idSelected[0]);
      }
      if (buttonId == "aplicarProd") {
        this.aplicarProd(idSelected)
      }
    },
    aplicarProd(idSelected) {
      let datos = { Id: idSelected };
      this.$alert.alertConfirm({
        action: "enviar a inventario",
        obj: "la produccion",
        route: "AYB-Producciones-applyProduccion",
        data: datos,
        onSuccess: () => {
          //this.getPresentacionesByProduct()
          this.$emit("successData");
        },
      });
    },
    replyProduccion(id) {
      let dataProd = this.$pgsHelper.getById(this.Documentos, "id", id);
      let produccionReplicar = this.$pgsHelper.cloneObj(dataProd);
      produccionReplicar.sts = "P";
      delete produccionReplicar.id;
      delete produccionReplicar.Crat;
      produccionReplicar.mmt = new moment().format("YYYY-MM-DD_HH:mm:ss");
      this.$alert.alertConfirm({
        action: "Replicar",
        obj: "el documento de produccion",
        route: "AYB-Producciones-createProduccion",
        data: produccionReplicar,
        onSuccess: () => {
          this.getDocuments();
        },
      });
    },
    optButtonClick(buttonId, ref) {
      if (buttonId == "editPrice") {
        this.editedHotel = this.getHotelinfoById(ref);
        this.toggleModal(true);
      }
    },
    getDocuById(code) {
      let itemIndex = this.$_.findIndex(this.Documentos, { id: code });
      if (itemIndex >= 0) {
        return this.Documentos[itemIndex];
      }

      return false;
    },
    async successData(data, doAction) {
      await this.getDocuments();
      this.showModal = false;
    },
    toggleModal(open) {
      this.showModal = open;
    },
    async deleteDoc(id) {
      let docu = this.getDocuById(id);

      let datos = {
        Id: id,
        TipoMovimiento: "Entrada",
      };

      this.$swal({
        title: "¿Deseas cancelar la producción de insumos?",
        text: "Al cancelar se revertira cualqueir operacion generada",
        icon: "warning",
        showCancelButton: true,
        confirmButtonColor: "#3085d6",
        cancelButtonColor: "#d33",
        confirmButtonText: "Cancelar",
        allowOutsideClick: false,
        showLoaderOnConfirm: true,
        preConfirm: async () => {
          return await this.$store.getters.getFirebaseApp.fba
            .call("AYB-Producciones-cancelProduccion", datos)
            .then(function (result) {
              return result;
            })
            .catch((error) => {
              this.$swal.showValidationMessage(`Request failed: ${error}`);
            });
        },
      }).then((result) => {
        if (result.value) {
          if (result.value.data.ok) {
            this.$swal("La producción se cancelo correctamente", "", "success");
            this.getDocuments();
          } else {
            this.$swal("Error deleting data", result.value.data.error, "error");
          }
        }
      });
    },
    async getDocuments() {
      const fechaInicio = moment(this.input_date).startOf('day').valueOf();
      const fechaFin = moment(this.input_date_final).endOf('day').valueOf();

      this.Documentos = [];
      const firestore = this.$store.getters.getFirebaseApp.firestore;
      var data = await firestore.queryBuilder("AYB_Produccion", [
        firestore.where(
          "Tenant",
          "==",
          this.$store.getters.getFirebaseApp.tenant
        ),
        firestore.where("Crat", ">=", fechaInicio),
        firestore.where("Crat", "<=", fechaFin),
      ]);

      let document = data.docs.map((doc) => {
        return { id: doc.ref.id, ...doc.data() };
      });
      document.forEach((data) => {
        let fecha = new moment(data.Crat);
        let origenData = this.getOrigenById(data.amc);
        this.Documentos.push({
          id: data.id,
          origenId: origenData.id,
          origenNombre: origenData.Nombre,
          Nombre: "Produccion-" + data.id,
          Fecha: fecha.format("YYYY-MM-DD HH:ss"),
          Departamento: data.dpt,
          Status: data.sts,
          Showby: data.sts === "P",
          ...data,
        });
      });
      this.Documentos = this.$_.orderBy(this.Documentos, "Fecha", "desc");
    },
    async getOrigenes() {
      var data = await this.$store.getters.getFirebaseApp.database.queryBuilder(
        "PDV/Inventario/Origenes"
      );
      if (!data.exists()) {
        return false;
      }
      let arrayOrg = Object.entries(data.val());
      let origenes = [];
      arrayOrg.forEach((element) => {
        if (!this.$route.params.idDocumento) {
          this.Origen = element[0];
        }
        //this.Origen =  element[0];
        origenes.push({
          id: element[0],
          Nombre: element[1]["Nombre"],
          Departamentos: element[1]["Departamentos"],
        });
      });

      this.origenes = origenes;
    },
    getOrigenById(code) {
      let itemIndex = this.$_.findIndex(this.origenes, { id: code });
      if (itemIndex >= 0) {
        return this.origenes[itemIndex];
      }

      return false;
    },
  },
  computed: {
    disableDates() {
      return { to: moment(this.input_date).startOf('day').toDate() };
    },
  },
  watch: {},
  async mounted() {
    await this.getDocuments();
  },
  async created() {
    await this.getOrigenes();
  },
};
</script>

<style>
.dateinputClass {
  border: 1px solid gray !important;
  border-radius: 4px !important;
}
</style>
